/* eslint-disable consistent-return */
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import {
  getEditUserLogado,
  getEditaSenha,
} from '../../services/EditUsers/getEditUsers'
import {
  ativarUserWhatsApp,
  deletaUserWhatsAppInstancia,
  getUserWhatsAppInstancia,
} from '../../services/EditUsers/getUserWhatsApp'
import { getConfiguracoesGetInstancia } from '../../services/Configuracoes/getConfiguracoes'
import { getUserData } from '../../services/ClienteDados/getClientData'
import { useTopUserData } from '../../components/Top/TopUserData/useTopUserData'

export const useEditUser = () => {
  const { userData } = useTopUserData()

  const [senha, setSenha] = useState('')
  const [novaSenha, setNovaSenha] = useState('')
  const [repetirSenha, setRepetirSenha] = useState('')
  const [showData, setShowData] = useState(true)
  const [showPassword, setShowPassword] = useState(false)
  const [showInputNameEmail, setShowInputNameEmail] = useState(false)
  const [campoObrigatorioSenhaAtual, setCampoObrigatorioSenhaAtual] =
    useState(false)
  const [campoObrigatorioNovaSenha, setCampoObrigatorioNovaSenha] =
    useState(false)
  const [campoObrigatorioConfirmarSenha, setCampoObrigatorioConfirmarSenha] =
    useState(false)
  const [senhaNaoConfere, setSenhaNaoConfere] = useState(false)
  const [campoObrigatorioNome, setCampoObrigatorioNome] = useState(false)
  const [campoObrigatorioEmail, setCampoObrigatorioEmail] = useState(false)
  const [alteraEmail, setAlteraEmail] = useState('')
  const [alteraNome, setAlteraNome] = useState('')
  const [teste, setTeste] = useState(false)

  // WhatsApp pessoal do usuario (instancia propria no banco master).
  const [showWhatsApp, setShowWhatsApp] = useState(false)
  // A secao so aparece se a organizacao atual tiver WhatsApp ativo.
  const [tenantWhatsAppAtivo, setTenantWhatsAppAtivo] = useState(false)
  const [whatsappInstancia, setWhatsappInstancia] =
    useState<GetConfiguracoesInstacia>({} as GetConfiguracoesInstacia)
  const [whatsappLoading, setWhatsappLoading] = useState(false)
  const [desconectarWhatsApp, setDesconectarWhatsApp] = useState(false)
  const [buscaWhatsApp, setBuscaWhatsApp] = useState(true)

  const fetchTenantWhatsAppAtivo = async () => {
    const result = await getConfiguracoesGetInstancia()
    if (!('message' in result)) {
      setTenantWhatsAppAtivo(!!result.ativo)
    }
  }

  // Resolve o id do usuario logado sem depender do timing do useTopUserData:
  // usa o userData se ja carregou, senao busca o /central/usuario/me na hora.
  const resolveUserId = async (): Promise<number | null> => {
    // Atencao: o id pode ser 0 (admin seed). Nunca usar checagem "truthy".
    if (userData?.id != null) return userData.id
    const result = await getUserData()
    if ('message' in result) return null
    return result.id ?? null
  }

  const fetchWhatsappInstancia = async () => {
    const id = await resolveUserId()
    if (id == null) return
    setWhatsappLoading(true)
    const result = await getUserWhatsAppInstancia(id)
    setWhatsappLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      setWhatsappInstancia(result)
    }
  }

  const fetchAtivarWhatsApp = async () => {
    const id = await resolveUserId()
    if (id == null) {
      toast.error(
        'Não foi possível identificar o usuário. Recarregue a página.'
      )
      return
    }
    setWhatsappLoading(true)
    const result = await ativarUserWhatsApp(id)
    setWhatsappLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      toast.success(result.info)
      fetchWhatsappInstancia()
    }
  }

  const fetchDeletaWhatsApp = async () => {
    const id = await resolveUserId()
    if (id == null) {
      toast.error(
        'Não foi possível identificar o usuário. Recarregue a página.'
      )
      return
    }
    setWhatsappLoading(true)
    const result = await deletaUserWhatsAppInstancia(id)
    setWhatsappLoading(false)
    if ('message' in result) {
      toast.error(result.message)
    } else {
      toast.success(result.sucesso)
      fetchWhatsappInstancia()
    }
  }

  const handleDeletaWhatsApp = () => setDesconectarWhatsApp(true)
  const fechaDesconectarWhatsApp = () => setDesconectarWhatsApp(false)
  const desconectarWhatsAppInstancia = () => {
    setDesconectarWhatsApp(false)
    fetchDeletaWhatsApp()
  }

  const fetchEditaSenha = async () => {
    const alteraSenhaRequestDTO = {
      senhaAtual: senha,
      senhaNova: novaSenha,
      senhaNovaConfirmacao: repetirSenha,
    }
    const result = await getEditaSenha(alteraSenhaRequestDTO)
    if ('info' in result) {
      toast.success(result.info)

      return
    }
    toast.error(result.message)
  }

  const fetchEditaUsuario = async () => {
    const alteraUsuarioDTO = {
      email: alteraEmail,
      nome: alteraNome,
    }
    const result = await getEditUserLogado(alteraUsuarioDTO)
    if ('info' in result) {
      toast.success(result.info)
      const timer = setTimeout(() => {
        window.location.reload()
      }, 1000)
      return () => clearTimeout(timer)
    }
    toast.error(result.message)
  }

  const handleChangeSetData = () => {
    setShowData(!showData)
    if (showPassword) setShowPassword(false)
    if (showWhatsApp) setShowWhatsApp(false)
    setShowInputNameEmail(false)
  }

  const handleChangeSetPassword = () => {
    setShowPassword(!showPassword)
    if (showData) setShowData(false)
    if (showWhatsApp) setShowWhatsApp(false)
  }

  const handleChangeSetWhatsApp = () => {
    setShowWhatsApp(!showWhatsApp)
    if (showData) setShowData(false)
    if (showPassword) setShowPassword(false)
  }

  const handleClickSetInput = () => {
    setShowInputNameEmail(!showInputNameEmail)
  }

  const handleAlteraNomeEmail = () => {
    setCampoObrigatorioNome(false)
    setCampoObrigatorioEmail(false)
    if (alteraNome.length === 0) {
      setCampoObrigatorioNome(true)
    } else if (alteraEmail.length === 0) {
      setCampoObrigatorioEmail(true)
    } else {
      fetchEditaUsuario()
    }
  }
  const handleValidaSenha = () => {
    setCampoObrigatorioSenhaAtual(false)
    setCampoObrigatorioNovaSenha(false)
    setCampoObrigatorioConfirmarSenha(false)
    setSenhaNaoConfere(false)
    if (senha.length === 0) {
      setCampoObrigatorioSenhaAtual(true)
    } else if (novaSenha.length === 0) {
      setCampoObrigatorioNovaSenha(true)
    } else if (repetirSenha.length === 0) {
      setCampoObrigatorioConfirmarSenha(true)
    } else if (repetirSenha !== novaSenha) {
      setSenhaNaoConfere(true)
    } else {
      fetchEditaSenha()
    }
  }

  const handleEdit = () => {
    localStorage.setItem('nomeUsuario', JSON.stringify(userData?.nome))
    localStorage.setItem('emailUsuario', JSON.stringify(userData?.email))
    setTeste(!teste)
  }

  const handleClear = () => {
    localStorage.removeItem('nomeUsuario')
    localStorage.removeItem('emailUsuario')
  }

  useEffect(() => {
    const nomeUsuario = localStorage.getItem('nomeUsuario')
    const emailUsuario = localStorage.getItem('emailUsuario')

    if (nomeUsuario) {
      setAlteraNome(JSON.parse(nomeUsuario))
    }
    if (emailUsuario) {
      setAlteraEmail(JSON.parse(emailUsuario))
    }
  }, [teste])

  // Define se a secao "WhatsApp pessoal" deve aparecer (tenant com WhatsApp ativo).
  useEffect(() => {
    fetchTenantWhatsAppAtivo()
  }, [])

  // Carrega o status/QR assim que a secao abre (o id e resolvido sob demanda).
  useEffect(() => {
    if (showWhatsApp) {
      fetchWhatsappInstancia()
    }
  }, [showWhatsApp])

  // Polling do status/QR enquanto a secao estiver aberta (mesmo intervalo da
  // tela de Configuracoes da organizacao).
  useEffect(() => {
    if (!showWhatsApp) return undefined
    const timer = setTimeout(() => {
      fetchWhatsappInstancia()
      setBuscaWhatsApp(!buscaWhatsApp)
    }, 15000)
    return () => clearTimeout(timer)
  }, [buscaWhatsApp, showWhatsApp])

  return {
    handleEdit,
    showData,
    handleChangeSetData,
    showPassword,
    handleChangeSetPassword,
    handleClickSetInput,
    senha,
    setSenha,
    novaSenha,
    setNovaSenha,
    repetirSenha,
    setRepetirSenha,
    fetchEditaSenha,
    campoObrigatorioSenhaAtual,
    setCampoObrigatorioSenhaAtual,
    campoObrigatorioNovaSenha,
    setCampoObrigatorioNovaSenha,
    campoObrigatorioConfirmarSenha,
    setCampoObrigatorioConfirmarSenha,
    senhaNaoConfere,
    setSenhaNaoConfere,
    handleValidaSenha,
    handleAlteraNomeEmail,
    setAlteraEmail,
    setAlteraNome,
    campoObrigatorioNome,
    campoObrigatorioEmail,
    fetchEditaUsuario,
    showInputNameEmail,
    userData,
    alteraNome,
    alteraEmail,
    handleClear,
    showWhatsApp,
    handleChangeSetWhatsApp,
    tenantWhatsAppAtivo,
    whatsappInstancia,
    whatsappLoading,
    fetchAtivarWhatsApp,
    handleDeletaWhatsApp,
    desconectarWhatsApp,
    fechaDesconectarWhatsApp,
    desconectarWhatsAppInstancia,
  }
}
